import { ParamHistorical } from '../../../../../shared/types/param';

export interface SubtypeDPParamsHistoricalProps {
    historical: ParamHistorical[];
    showHistorical?: boolean;
}

export const fieldEquivalences: { [key: string]: string } = {
    createAt: 'Fecha de creación',
    name: 'Nombre',
    extra2: 'Descripción',
    active: 'Estado',
    parent: 'Medio',
    nestedParent: 'Tipo PQR',
};
